import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subject} from "rxjs";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {ActivityLog, LogService} from "../../services/log.service";
import {MatSelectChange} from "@angular/material/select";
import {MatDialog} from "@angular/material/dialog";
import {ChangesComponent} from "./changes/changes.component";
import {IpService} from "../../services/ip.service";

@Component({
    selector: 'app-activity-log',
    templateUrl: './activity-log.component.html',
    styleUrls: ['./activity-log.component.scss']
})
export class ActivityLogComponent implements OnInit ,OnDestroy{

    startDateFilter: Date | null = null;
    endDateFilter: Date | null = null;
    private _destroyed$=new Subject()
    @ViewChild(MatPaginator) paginator1!: MatPaginator;
    @ViewChild(MatSort) sort1!: MatSort;
    dataSource: MatTableDataSource<ActivityLog>;
    data:ActivityLog[]=[]
    filterdata:ActivityLog[]=[]
    actionSelected='All'
    sectionSelected='All'
    logCountSelected = 1000;
    logCountOptions: number[] = [1000, 3000, 5000, 10000,15000];
    displayedColumns: string[] = ['date', 'section','action','user','description' ,'currentIp', 'changes'];
  action: string[] = ['All', ...['Delete', 'Login', 'Logout', 'Submit', 'Update', 'View', 'Filter', 'Receipt'].sort((a, b) => a.localeCompare(b))];
  section: string[] = ['All', ...['Admission','Assessment Counseling', 'Counselling Reports','Products','Instock Entry',
    'Category Types','Sub Category Types','Stock Adjustment','Stock Transfer','Direct Issue','Issue Requests',
    'Product Request','Purchase List','Child Highlight','Child Case Study',
    'Centre', 'Donor','Donation', 'Employee','Feedback','Group Counseling', 'Group Education', 'Hospital','Individual Counseling', 'Individual Education', 'Inventory', 'Login', 'Logout','Media','MoM','Prescreening', 'Types', 'Unit Sponsorship', 'Vehicle','Volunteer','8080 Inquiry'].sort((a, b) => a.localeCompare(b))];

  filterstring='';
    constructor(private mService:LogService,
                private ipService:IpService,
                private matdialog: MatDialog) {
        this.dataSource = new MatTableDataSource<ActivityLog>(this.data)
    }

    ngOnInit(): void {
      this.loadLogs();
    }

    loadLogs() {
      this.mService.getLogsByCount(this.logCountSelected)
        .then(snapshot => this.onLogsFetched(snapshot))
        .catch(err => console.error('Failed to load logs:', err));
    }

    loadLogsByDateRange(start: number, end: number) {
      this.mService.getLogsByDateRange(start, end)
        .then(snapshot => this.onLogsFetched(snapshot))
        .catch(err => console.error('Failed to load logs by date range:', err));
    }

    private onLogsFetched(snapshot: any) {
      const res: ActivityLog[] = [];
      snapshot.forEach((child: any) => {
        res.push({ key: child.key, ...child.val() });
        return false;
      });

      this.data = res;
      this.data.reverse();
      this.dataSource = new MatTableDataSource<ActivityLog>(this.data);
      this.dataSource.paginator = this.paginator1;
      this.applyClientFilters();
    }

    onLogCountChange($event: MatSelectChange) {
      console.log('Log count changed to:', $event.value);
      this.logCountSelected = $event.value;
      this.loadLogs();
    }

    ngOnDestroy(): void {
        this._destroyed$.next('')
        this._destroyed$.complete()
    }

    onAction($event: MatSelectChange) {
        this.actionSelected = $event.value
        this.applyClientFilters()
    }

    onSection($event: MatSelectChange) {
        this.sectionSelected = $event.value
        this.applyClientFilters()
    }


    clearAll() {
        this.actionSelected ='All'
        this.sectionSelected='All'
      this.startDateFilter=null
      this.endDateFilter=null
      this.filterstring=''
      this.dataSource.filter=''
      this.loadLogs()
    }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // Fetches from RTDB scoped by the selected date range (server-side), then
  // relies on applyClientFilters() to narrow by section/action/search locally.
  applyDateRangeFilter() {
    if (!this.startDateFilter || !this.endDateFilter) {
      this.loadLogs();
      return;
    }

    // Start of the start date (00:01:00) so the whole day is included
    const startOfStartDate = new Date(this.startDateFilter).setHours(0, 1, 0, 0);
    // End of the end date (23:59:59) so the whole day is included
    const endOfEndDate = new Date(this.endDateFilter).setHours(23, 59, 59, 999);

    this.loadLogsByDateRange(startOfStartDate, endOfEndDate);
  }

  // Applies section/action filters on top of whatever is currently loaded
  // in this.data (either the last-N fetch or a date-range fetch).
  private applyClientFilters() {
    this.filterdata = this.data.filter(item => {
      const isSectionMatched = this.sectionSelected === 'All' ? true : item.section === this.sectionSelected;
      const isActionMatched = this.actionSelected === 'All' ? true : item.action === this.actionSelected;
      return isSectionMatched && isActionMatched;
    });

    this.dataSource.data = this.filterdata;
  }



  // @ts-ignore

  viewChanges(element:any) {
    this.matdialog.open(ChangesComponent,
      {
        width: '50%', height: '300px',
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '200ms',
        data: element
      })


  }
}
